import {
  Box,
  Typography,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import { SearchRounded, TagRounded, TuneRounded } from "@mui/icons-material";
import { AnimatePresence, motion } from "framer-motion";
import { useProductFilters } from "../../context/ProductFilterContext";
import ProductDetail from "./ProductDetail";
import { useAuth } from "../../context/AuthContext";
import ProductSection from "./ProductsSection";

export default function Products() {
  const { user } = useAuth();
  const {
    page,
    categories,
    priceOrder,
    namePrefix,
    skuPrefix,
    setPage,
    setCategories,
    setPriceOrder,
    setNamePrefix,
    setSkuPrefix,
    products,
    pages,
    totalProducts,
    allCategories,
  } = useProductFilters();

  const { selectedProduct, setSelectedProduct, clearSelectedProduct } =
    useProductFilters();

  return (
    <Box sx={{ width: "100%", maxWidth: 1460, mx: "auto", p: { xs: 2, md: 3 } }}>
      <AnimatePresence mode="wait" initial={false}>
      {selectedProduct ? (
        <motion.div key="product-detail" initial={{ opacity: 0, x: 28 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} transition={{ duration: .32, ease: [0.22, 1, 0.36, 1] }}>
          <ProductDetail product={selectedProduct} onBack={clearSelectedProduct} />
        </motion.div>
      ) : (
        <motion.div key="product-gallery" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: .25 }}>
          <Box
            sx={{
              mb: 4,
              bgcolor: "rgba(255,253,248,.86)",
              p: { xs: 2, md: 2.5 },
              borderRadius: 3,
              border: "1px solid rgba(24,36,29,.1)",
              boxShadow: "0 16px 45px rgba(35,45,37,.07)",
              backdropFilter: "blur(14px)",
              position: { xs: "static", lg: "sticky" },
              top: 96,
              zIndex: 10,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mb: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}><TuneRounded color="secondary"/><Typography fontWeight={800}>Refine the collection</Typography></Box>
              <Typography component="span" variant="body2" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>{totalProducts} pieces</Typography>
            </Box>
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: ".8fr 1.2fr 1.2fr auto" }, gap: 1.5, alignItems: "center" }}>
            <TextField
              label="SKU"
              variant="outlined"
              size="small"
              value={skuPrefix}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setSkuPrefix(value);
                }
              }}
              slotProps={{
                input: {
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  startAdornment: <InputAdornment position="start"><TagRounded fontSize="small" /></InputAdornment>,
                },
              }}
              sx={{ flex: 1 }}
            />
            <TextField
              label="Search by Name"
              variant="outlined"
              size="small"
              value={namePrefix}
              onChange={(e) => setNamePrefix(e.target.value)}
              sx={{ flex: 1 }}
              slotProps={{ input: { startAdornment: <InputAdornment position="start"><SearchRounded fontSize="small" /></InputAdornment> } }}
            />

            <Autocomplete
              multiple
              options={allCategories}
              value={categories}
              onChange={(event, newValue) => setCategories(newValue)}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField {...params} label="Categories" size="small" />
              )}
              sx={{ minWidth: { xs: "100%", md: 250 }, flex: 1 }}
            />

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ToggleButtonGroup
                value={priceOrder}
                exclusive
                onChange={(e, value) => value && setPriceOrder(value)}
                sx={{ borderRadius: 2, height: "40px" }}
              >
                <ToggleButton value="asc">Price ↑</ToggleButton>
                <ToggleButton value="desc">Price ↓</ToggleButton>
              </ToggleButtonGroup>
            </Box>
            </Box>
          </Box>

          <ProductSection
            products={products}
            user={user}
            onSelectProduct={setSelectedProduct}
            onSetPage={setPage}
            page={page}
            pages={pages}
          />
        </motion.div>
      )}
      </AnimatePresence>
    </Box>
  );
}
